import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class DataSource {
    constructor(doc)
    {
		this.label = null;
		this.dataSourceEffectiveDate = null;
		this.dataSourceIdentifier = null;
		this.dataSourceName = null;
		this.dataSourceQualityRatingCode = null;
		this.dataSourceType = null;
		this.dataSourceTypeOtherDescription = null;

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.dataSourceEffectiveDate = x.getMISMODateElement(doc, "./ns:DataSourceEffectiveDate");
		this.dataSourceIdentifier = x.getStringElement(doc, "./ns:DataSourceIdentifier");
		this.dataSourceName = x.getStringElement(doc, "./ns:DataSourceName");
		this.dataSourceQualityRatingCode = x.getStringElement(doc, "./ns:DataSourceQualityRatingCode");
		this.dataSourceType = x.getStringElement(doc, "./ns:DataSourceType");
		this.dataSourceTypeOtherDescription = x.getStringElement(doc, "./ns:DataSourceTypeOtherDescription");
   }

	GetSourceType() {
		var source = h.descriptionOrOther(this.dataSourceType, this.dataSourceTypeOtherDescription);
		if (source === "") source = this.dataSourceName;
		return source;
	}

	GetSourceTypeOrName() {
		var source = h.descriptionOrOther(this.dataSourceType, this.dataSourceTypeOtherDescription);
		if (source === "") source = h.toEnumText(this.dataSourceName);
		return source;
	}
}

export class DataSources {
    constructor(doc)
    {
		this.label = null;
		this.dataSourceList = [];
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:DATA_SOURCE");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.dataSourceList.push(new DataSource(xn));
			});
		}
   }

	GetDataSourceByLabel(label)	{
		for (var ds of this.dataSourceList)
				if (label === ds.label)
						return ds;
		return "";
	}

	GetDataSourceClass(labels) {
		for(var label of labels)
				for (var ds of this.dataSourceList)
						if (label === ds.label)
								return ds;
		return "";
	}

	GetDataSourceType(label)	{
		for (var ds of this.dataSourceList)
				if (label === ds.label || ds.label.endsWith(label)) {
						var result = ds.GetSourceType();
						result = h.addWithSpace(result, ds.dataSourceIdentifier);
						return result;
				}

		return "";
	}

	GetDataSourceName(label) {
		for (var ds of this.dataSourceList)
				if (label === ds.label || ds.label.endsWith(label)) {
						return ds.dataSourceName;
				}

		return "";
	}

	GetDataSourceTypes(label) {
		for (var ds of this.dataSourceList)
				if (label === ds.label || ds.label.endsWith(label)) {
						return ds.GetSourceType();
				}

		return "";
	}

	GetDataSource(labels) {
		var sources = "";
		for (var label of labels) {
				//console.log("label: ", label, this.dataSourceList);
				for (var ds of this.dataSourceList) {
						//console.log("ds: ", ds);
						if (label === ds.label || ds.label.endsWith(label)) {
								var result = ds.GetSourceType();
								sources = h.addWithNewline(sources, result);
						}
				}
		}
		return sources;
	}
}

